import { render, staticRenderFns } from "./AdminNaehrwerteLebensmittelDetails.vue?vue&type=template&id=0760a189&"
import script from "./AdminNaehrwerteLebensmittelDetails.vue?vue&type=script&lang=js&"
export * from "./AdminNaehrwerteLebensmittelDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdminNaehrwerteLebensmittelDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports